import React, {useState, useRef, useEffect} from 'react';
import {useSelector} from 'react-redux';
import UserProfileReview from './UserProfileReview';
import CreateReview from './CreateReview';

const ManageReview = (props) => {

    const {currentReviewId, showList} = props;
    let user = useSelector(state=>state.user);
    const [step, editStep] = useState(false);
    const isMounted = useRef(null);
    
    useEffect( ()=> {
        checkUserProfile();
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        }
    });

    const checkUserProfile = () => {
        if ( !user.firstName || user.firstName.length<3 || !user.lastName || user.lastName.length<3  ) {
            editStep('profile');
        } else {
            editStep('create');
        }
    }; 

    const goToReview = () => { editStep('create')};
    const gotToProfile = () => {editStep('profile')};
    

    return (
        step == 'profile' ? 
        <UserProfileReview 
            fName={user.firstName}
            lName={user.lastName}
        /> 
        : 
        <CreateReview 
            currentReviewId={currentReviewId} 
            gotToProfile={gotToProfile}
            showList={showList}
        />
    );
}

export default ManageReview;